import { render, staticRenderFns } from "./PrintShotCard.vue?vue&type=template&id=81fe0bc4&"
import script from "./PrintShotCard.vue?vue&type=script&lang=js&"
export * from "./PrintShotCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports